export const CategorizedListContainer = ({ children }) => (
  <div className="w-full gap-7 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">{children}</div>
)
